import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";

const DetailsInfoContainer = styled.ul`
  border-top: 1px solid ${colorPalette.rabbitGrey};
  display: flex;
  margin-bottom: 3px;
  margin-top: 3px;
  padding: 3px;
`;

const DetailCell = styled.li`
  align-items: center;
  border-right: ${({ hasRightBorder }) =>
    hasRightBorder ? `1px solid ${colorPalette.rabbitGrey}` : "0"};
  display: flex;
  justify-content: center;
  padding-left: ${({ hasLeftPadding }) => (hasLeftPadding ? `10px` : "0")};
  padding-right: ${({ hasRightPadding }) => (hasRightPadding ? `10px` : "0")};
  text-align: ${({ hasLeftPadding }) => (hasLeftPadding ? "center" : "left")};
`;

const DetailText = styled(Text).attrs({ type: "sm" })``;

DetailCell.displayName = "DetailCell";
DetailsInfoContainer.displayName = "DetailsInfoContainer";
DetailText.displayName = "DetailText";

export { DetailCell, DetailsInfoContainer, DetailText };
